import styles from './styles.module.scss';
import { useWalletsMe } from '@/api/wallets';
import { WalletService } from '@starsoft/common/services';
import useTranslation from 'next-translate/useTranslation';
import { useToggle } from '@starsoft/common/hooks';
import { getMoneyOrAmount } from '@starsoft/common/utils';
export default function InfoBalance() {
  const { t } = useTranslation('common');
  const [isOpen, toggleOpen] = useToggle(false);
  const { wallet } = useWalletsMe();

  function getTotalBalance(): string {
    return WalletService.maskCurrency({
      amount: getMoneyOrAmount(wallet?.totalBalanceInDollars),
    });
  }
  const formatedValue = getTotalBalance();
  const hiddenValue = formatedValue.replace(/./g, '-');

  return (
    <div className={styles['estimated-balance']}>
      <span className={styles['estimated-balance__title']}>
        {t('noempty_wallet_titleLabel')}{' '}
        <span className={styles['estimated-balance__icon']}>
          <i
            className={`fa-solid ${isOpen ? 'fa-eye' : 'fa-eye-slash'}`}
            onClick={toggleOpen}
          />
        </span>
      </span>
      <span className={styles['estimated-balance__value']}>
        {isOpen ? formatedValue : hiddenValue}{' '}
      </span>
    </div>
  );
}
